// npm i n3
import { Parser, Writer } from "n3";

/**
 * Вход: N-Triples строка вида:
 *   <s> <p> <o> .
 *   <s2> <p2> "literal"@ru .
 *
 * Выход: SPARQL INSERT DATA { ... }
 */
const RDF_FORMATS = {
  N_TRIPLES: "application/n-triples",
  TURTLE: "text/turtle",
};

export function normalizeRdfFormat(format) {
  const value = String(format || "").trim().toLowerCase();
  if (["turtle", "ttl", "text/turtle"].includes(value)) return RDF_FORMATS.TURTLE;
  if (["n-triples", "n-triple", "ntriples", "nt", "n3", "application/n-triples"].includes(value)) {
    return RDF_FORMATS.N_TRIPLES;
  }
  throw new Error(`Unsupported RDF format: ${format || "empty"}`);
}

export async function ntriplesToInsertData(rdfText, { graphIri = null, format = "N-Triples" } = {}) {
  // Parse RDF according to the export format. Turtle prefixes and compact syntax
  // are expanded by N3 before the data is embedded into SPARQL.
  const rdfFormat = normalizeRdfFormat(format);
  const parser = new Parser({ format: rdfFormat });

  let quads;
  try {
    quads = parser.parse(rdfText);
  } catch (e) {
    const formatName = rdfFormat === RDF_FORMATS.TURTLE ? "Turtle" : "N-Triples";
    throw new Error(`${formatName} parse error: ${e.message}`);
  }

  // 2) Serialize обратно в N-Triples (подходит для INSERT DATA)
  const nt = await new Promise((resolve, reject) => {
    const writer = new Writer({ format: "application/n-triples" });
    writer.addQuads(quads);
    writer.end((err, result) => (err ? reject(err) : resolve(result)));
  });

  // 3) Собираем SPARQL
  const dataBlock = graphIri
    ? `GRAPH <${graphIri}> {\n${nt}\n}`
    : `${nt}`;

  return `INSERT {\n${dataBlock}\n}`;
}

/**
 *  Cформировать DELETE WHERE через VALUES, чтобы удалить все триплеты, где субъект входит в массив IRIs
 * 
 * Для IRIs = [ 'http://purl.semanticpro.org/skos/UnderDevelopment', 'http://purl.semanticpro.org/skos/Approved'];
 * будет сформирован 
 * DELETE {  ?s ?p ?o . }
 * WHERE {
 *  VALUES ?s {
 *    <http://purl.semanticpro.org/skos/UnderDevelopment>
 *    <http://purl.semanticpro.org/skos/Approved>
 *  }
 *  ?s ?p ?o .
 * }
 */
export async function buildDeleteSPARQL (IRIs = [], graph = undefined) {
  const subjects = [...new Set(IRIs)]
    .filter(Boolean)
    .map(iri => `<${iri}>`)
    .join('\n    ');

  if (!subjects) {
    throw new Error('IRIs is empty');
  }

  const graphBlockStart = graph ? `GRAPH <${graph}> {` : '';
  const graphBlockEnd = graph ? `}` : '';

  return `
DELETE {
  ${graphBlockStart}
    ?s ?p ?o .
  ${graphBlockEnd}
}
WHERE {
  VALUES ?s {
    ${subjects}
  }

  ${graphBlockStart}
    ?s ?p ?o .
  ${graphBlockEnd}
}
`.trim();
};
